import { render, staticRenderFns } from "./ActivationsTable.vue?vue&type=template&id=1435f328&"
import script from "./ActivationsTable.vue?vue&type=script&lang=js&"
export * from "./ActivationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports